"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CardMedia = _interopRequireDefault(require("@mui/material/CardMedia"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _styles = require("./styles");
var _BlackLogo = _interopRequireDefault(require("shared/dist/assets/images/BlackLogo.svg"));
var _WhiteLogo = _interopRequireDefault(require("shared/dist/assets/images/WhiteLogo.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SnetSvgLogo = {
  white: _BlackLogo.default,
  purple: _WhiteLogo.default
};
const Logo = _ref => {
  let {
    headerColor,
    portalName,
    handleClick
  } = _ref;
  const classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.logoContainer,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_CardMedia.default, {
    component: "img",
    image: SnetSvgLogo[headerColor],
    alt: "SingularityNET"
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h5"
  }, portalName));
};
Logo.propTypes = {
  headerColor: _propTypes.default.string,
  portalName: _propTypes.default.string
};
var _default = exports.default = Logo;